import script from "./CollectionsListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectionsListView.vue?vue&type=script&lang=ts&setup=true"

import "./CollectionsListView.vue?vue&type=style&index=0&id=5c057469&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c057469"]])

export default __exports__